import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Read the server-controlled public profile projection first. During migration,
 * fall back to the legacy users document so existing profiles continue working
 * before the projection has been backfilled for every account.
 */
export async function getPublicProfile(userId) {
  if (!userId) return null;

  const publicSnap = await getDoc(doc(db, 'public_profiles', userId));
  if (publicSnap.exists()) {
    return publicSnap.data();
  }

  const legacySnap = await getDoc(doc(db, 'users', userId));
  return legacySnap.exists() ? legacySnap.data() : null;
}
